var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CardProductSpecItemCmp d-flex align-items-center justify-content-between"},[_c('span',{staticClass:"font-medium"},[_vm._t("label")],2),_c('span',[_vm._t("value")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }